import { userApi } from './index';
import { UnionAccount, IUserAvailableServices } from '../../../models/Accounts';
import { config } from '../config';

export const unionApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    getUnionInfo: build.query<UnionAccount, { accountId: string }>({
      query: ({ accountId }) => ({
        url: config.UNION.ACCOUNT_INFO(accountId),
      }),
      providesTags: () => ['Accounts'],
    }),
    getAvailableUnionServices: build.query<IUserAvailableServices, { accountId: string }>({
      query: ({ accountId }) => ({
        url: config.UNION.SERVICES_AVAILABLE(accountId),
      }),
      providesTags: () => ['Accounts'],
    }),
  }),
});
